import config from "@/config"

export const state = {

    user: {},
    token: null,
    filter: false,
    title: '',
    method: "",
    warnTimeout: null,
    sessionTimeout: null,
    isShowSMSidebar: true,
    isBlock: false,
    //force block/not block 
    forceBlock: true,
    changeTracker: false,
    linkHandling: null,
    response: null,
    // words:[],
    // params:[],
    // locales:[],
    isShowFormBuilderMenu:false,
    sidLogin:false
}

export const mutations = {
    switchSidebar() {
        state.isShowSMSidebar = !state.isShowSMSidebar
    },
    linkHandling(state, obj) {
        state.linkHandling = obj;
    },
    resetLinkHandling(state) {
        state.linkHandling = null;
    },
    setChangeTracker() {
        state.changeTracker = !state.changeTracker
    },
    setForceBlock(state, forceBlock) {
        state.forceBlock = forceBlock;
    },
    // setWord(state,word){
    //     state.words = word;
    // },
    // setParams(state,params){
    //     state.params = params;
    // },
    // setLocales(state,locales){
    //     state.locales = locales;
    // },
    setBlock(state, isBlock) {
        state.isBlock = isBlock;

        if (state.isBlock && state.forceBlock) {
            NProgress.start();
            $('#mainWrapper').block({
                message: '<i class="icon-spinner2 spinner"></i>',
                overlayCSS: {
                    backgroundColor: 'none',
                    opacity: 0.8,
                    cursor: 'wait',
                    'box-shadow': '0 0 0 1px #ddd'
                },
                css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: 'none'
                }
            })
        } else if (!state.isBlock && state.forceBlock) {
            NProgress.done();
            $('#mainWrapper').unblock();
        }
    },
    setUser(state, user) {
        window.localStorage.setItem(
            "ccrs_user",
            JSON.stringify(user)
        );



    },
    runMethod(state, { component, name }) {
        state.method = {
            component: component,
            name: name
        };
    },

    setResponse(state, { isSuccess, r, id }) {
        let obj = {
            success: isSuccess,
            r: r,
            id: id
        }
        state.response = obj;

    },


    setToken(state, token) {
        // state.token = token

        window.localStorage.setItem("ccrs_token", token)

    },
    setFilter(state, filter) {
        state.filter = filter
    },
    resetTimeout(state) {
        clearTimeout(state.warnTimeout)
        clearTimeout(state.sessionTimeout)

        state.warnTimeout = setTimeout(
            function () {
                $('#warnDialog').modal('show')
            }, config.sessionWarn * 60000
        )

        state.sessionTimeout = setTimeout(
            function () {
                $('#warnDialog').modal('hide')
                $('#timeoutDialog').modal('show')
            }, config.sessionTimeout * 60000
        )
    },
    setFormBuilderMenu(state,isShow){
        state.isShowFormBuilderMenu = isShow;
    },
    setSidLogin(state,sidLogin){
        state.sidLogin = sidLogin
    }
}

export const actions = {
    actionSetSidLogin: ({ commit }, sidLogin) => {
        commit('setSidLogin', sidLogin);
    },
    actionSetUser: ({ commit }, user) => {
        commit('setUser', user);
    },
    actionSetToken: ({ commit }, token) => {
        commit('setToken', token);
    },
    actionSetFilter: ({ commit }, filter) => {
        commit('setFilter', filter);
    },
    actionLinkHandling: ({ commit }, obj) => {
        commit('linkHandling', obj);
    },
    actionSetForceBlock: ({ commit }, forceBlock) => {
        commit('setForceBlock', forceBlock);
    },
    actionResetTimeout: ({ commit }) => {
        commit('resetTimeout');
    },
    actionSetChangeTracker: ({ commit }) => {
        commit('setChangeTracker');
    },
    actionSwitchSidebar: ({ commit }) => {
        commit('switchSidebar');
    },
    actionSetBlock: ({ commit }, isBlock) => {
        commit('setBlock', isBlock);
    },
    actioResetlinkHandling: ({ commit }) => {
        commit('resetLinkHandling');
    },

    actioSetResponse: ({ commit }, { isSuccess, r, id }) => {
        commit('setResponse', { isSuccess, r, id })
    },
    actionSetFormBuilderMenu: ({ commit },isShow) => {
        commit('setFormBuilderMenu',isShow);
    },
    
    
}


export const getters = {
    getChangeTracker: state => state.changeTracker,
    getLinkHandling: state => state.linkHandling,
    getIsBlock: state => state.isBlock,
    getResponse: state => state.response,
    getVm: state => state.vm,
    getParams: state => state.params,
    getIsShowFormBuilderMenu: state => state.isShowFormBuilderMenu,
    getSidLogin: state => state.sidLogin,
    
}